import StyleSheetRW from "core/StyleSheetRW";
import { rh } from "core/designHelpers";
const styles = StyleSheetRW.create(() => ({
  outerView: { display: "flex", flexDirection: "row", height: "100%" },
  genderField: { paddingLeft: "13px" },
  nameField: { marginLeft: 10 },
  defaultImageStyle: {
    height: 50,
    width: 50,
    borderRadius: 100,
    backgroundColor: "#0000000D",
  },
  userRecord: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  tableStart: {
    width: "100%",
    fontFamily: "Outfit",
  },
  tableBody: { fontSize: 12, fontWeight: "300" },
  tableRow: { backgroundColor: "#2F4858", color: "#FFFFFF" },
  reviewContainer: { width: "100%", marginTop: 26 },
  searchContainer: { color: "#333333", fontSize: 14, fontWeight: "600" },
  searchView: {
    fontFamily: "Outfit",
    borderTopRightRadius: 10,
    height: 45,
    outline: "none",
    borderRadius: 10,
    paddingLeft: 15,
    marginTop: 5,
    borderStyle: "none",
    backgroundColor: "#0000000D",
  },
  heading: {
    fontWeight: "700",
    marginTop: 20,
    fontSize: 36,
    color: "#2F4858",
  },
  timerContainer: {
    width: "100%",
    backgroundColor: "#e8f0eb",
    display: "flex",
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "8px",
    gap: "9px",
  },
  timeText: { fontSize: 36, fontWeight: "500" },
  tableHeading: { fontSize: 20, fontWeight: "bold", marginBottom: "10px" },
  tableHead: {
    padding: "8px",
    textAlign: "left",
    borderBottom: "1px solid #2F4858",
    fontWeight: "300",
  },
  tableStyle: {
    cursor: "pointer",
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#FFFFFF66",
  },
  tableData1: { padding: "8px", borderLeft: "1px solid #2F485880" },
  tableData2: { padding: "8px", borderRight: "1px solid #2F485880" },
  body: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    marginTop: rh(35),
  },
}));

export default styles;
